var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{attrs:{"data-feather":_vm.feather}})}
var staticRenderFns = []

export { render, staticRenderFns }